"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colors = void 0;
exports.getSvgBackgroundColor = getSvgBackgroundColor;
var colors = ['#0099a9', '#2481d3', '#9462a6', '#e0487b', '#d38b4d', '#689f38'];
exports.colors = colors;
function getSvgBackgroundColor() {
  return colors[Math.floor(Math.random() * colors.length)];
}
//# sourceMappingURL=getSvgBackgroundColor.js.map